import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./fieldset-footer.module.scss";
import { FieldsetFooterStatus } from "./status";
import { FieldsetFooterActions } from "./actions";

export interface IFieldsetFooter {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetFooter = (props: IFieldsetFooter) => {
  return (
    <div className={cx(styles.fieldset_footer, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

FieldsetFooter.Status = FieldsetFooterStatus;
FieldsetFooter.Actions = FieldsetFooterActions;

FieldsetFooter.defaultProps = {};
